import Providers from './Providers';

export default Providers;
